import { TrendUp, Cube, Headset } from "@phosphor-icons/react";
import { Reveal } from "./motion";
import { useI18n } from "@/i18n";

const icons = [TrendUp, Cube, Headset];
const numbers = ["01", "02", "03"];

const MANIFESTO_IMG =
  "https://images.unsplash.com/photo-1645736315000-6f788915923b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";

export function Manifesto() {
  const { t } = useI18n();
  return (
    <section id="ventajas" className="relative bg-[#0a0a0a] border-y border-white/10">
      <div className="w-full max-w-screen-2xl mx-auto px-4 md:px-8 py-24 md:py-32 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="md:sticky md:top-28">
            <Reveal>
              <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#ff4500] mb-4">{t.manifesto.kicker}</p>
              <h2 className="font-clash font-black uppercase leading-[0.95] text-[#f5f5f5] text-4xl md:text-5xl tracking-tight mb-6">
                {t.manifesto.heading}
              </h2>
              <div className="aspect-[4/5] overflow-hidden border border-white/10 relative">
                <img src={MANIFESTO_IMG} alt="Warehouse operation" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505] to-transparent" />
                <div className="absolute bottom-5 left-5 font-mono text-[10px] uppercase tracking-widest text-[#a3a3a3]">
                  <span className="text-[#ff4500]">●</span> {t.manifesto.caption}
                </div>
              </div>
            </Reveal>
          </div>
        </div>

        <div id="proceso" className="md:col-span-7 flex flex-col">
          {t.manifesto.chapters.map((c, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={i} delay={i * 0.08}>
                <div className="relative py-10 md:py-14 border-b border-white/10 group">
                  <span className="absolute -top-2 right-0 font-clash font-black text-7xl md:text-9xl text-white/[0.04] select-none pointer-events-none">
                    {numbers[i]}
                  </span>
                  <div className="relative flex items-start gap-5 md:gap-8">
                    <div className="shrink-0 w-14 h-14 border border-white/15 flex items-center justify-center text-[#ff4500] group-hover:bg-[#ff4500] group-hover:text-[#050505] transition-colors duration-300">
                      <Icon size={26} weight="bold" />
                    </div>
                    <div>
                      <h3 className="font-clash font-bold text-2xl md:text-3xl text-[#f5f5f5] mb-3">{c.title}</h3>
                      <p className="font-plex text-[#a3a3a3] max-w-lg leading-relaxed">{c.body}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
          <Reveal delay={0.1}>
            <div className="mt-10 bg-[#111] border border-white/10 p-6 font-mono text-xs text-[#a3a3a3] leading-relaxed">
              <span className="text-[#ff4500]">*</span> {t.manifesto.note}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
